/**
 * @generated SignedSource<<d5f591b416e2a126eb582fb512c79ea0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_item$data = {
  readonly seller: {
    readonly " $fragmentSpreads": FragmentRefs<"SellerAwayBanner_seller">;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedContactDealerWrapper_item";
};
export type SharedContactDealerWrapper_item$key = {
  readonly " $data"?: SharedContactDealerWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SellerAwayBanner_seller"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "4de18edf78db3967015eb22b6f2c076a";

export default node;
